import { STRINGS } from 'config';
import React from 'react';
import { useAppState } from 'store/configureStore';

export interface IsUsedWithToolbarProps {
  children: React.ReactNode;
}

const IsUsedWithToolbar: React.FC<IsUsedWithToolbarProps> = ({ children }) => {
  const {
    app: {
      roles,
    },
  } = useAppState();

  const isToolbar: boolean = roles.includes(STRINGS.TOOLBAR.ROLE);

  if (isToolbar) {
    return children;
  }
  return <></>;
};

export default IsUsedWithToolbar;
